
/**
 *Created by jmmartinez on 6/8/18
 * v 1.1 16/06/2019 Añadida función getFormattedDateHyphenFromTimestamp
 *                  Añadida función getDateFromFormattedStringHyphensAndTime
 * v 1.2  11/09/2019 Añadida funcion getDateTimeFromFormattedString
 * v 1.3  25/09/2019 Añadida funcion getTimestampFromNowSinHora
 * v 1.4  21/10/2019 Añadida funcion getTimestampFromTimestampHora
 * v.1.5  04/11/2019 Añadida funcion getPeriodoUltimoMes
 * v.1.6  27/03/2020 Añadida función getFormattedDateTimeFromCadenaISO
 *                  Añadida función getMinutosEntreDates
 * v.1.7  03/06/2020 Añadida función getFormattedMesAgnoFromNow y getFormattedAgnoFromNow
 * v.1.8  12/06/2020 Añadida función getSegundosEntreDates
 * v.1.9  07/07/2020 Añadida función addDiasTimestamp
 * v.1.10 29/07/2020 Añadida funcion getDatesLunesPeriodo
 * v.2.0  26/10/2020 Modificadas las funciones de cálculo de periodo para que en el cálculo del hasta: getDateFromNowSinHora.


 * v.2.1  23/12/2020 Añadidas las funciones: calcularDateFromCadena,  diaAnteriorIgualADia y  diaAnteriorADia<
 * v.2.2  01/02/2021 PRotegemos el método calcularDateFromCadena de una entrada null, devolviendo el dia de hoy.
 * v.2.3  03/02/2021 En el método calcularDateFromCadena añadido el caso de un sólo número
 * v.2.1  17/11/2020 Añadida funcion getSegundosDesdeMinutosSegundos, addSegundos y getSegundosConSignoEntreDates
 * v.2.2  03/06/2021 Añadida función getFormattedHoraAhora
 * v.2.3  12/07/2021 Añadida función getMesAgnoHoy
 *        12/07/2021 Añadida la función minutosToCadenaHorasMinutos
 * v.2.4  25/04/2022 Añadidas la funciones getAgnoHoy y getDatesDiaPeriodo
 *        Modificado getDatesLunesPeriodo
 *

 * v.2.5 Union Planifikator y Sidemur
 * v.2.6  18/05/2022 Añadida funcion getDiasEntreFechas
 * v.2.7  26/05/2022 Añadida función getFormattedDateNow
 * v.2.8  03/06/2022 Modificada la función addDiasTimestamp
 * v.2.9  08/09/2022 Añadida función getDateFromFormattedStringHyphenReverse.
 *                   Añadida funcioń getDatesTodosDiasPeriodo.
 * v.2.10 10/10/2022 Añadida función getPeriodo15DiasCentrados
 *
 * v.2.11 28/03/2023 Añadida la función getDateFromFormattedStringHyphen
 * v.2.12 27/06/2023 Modificado el nombre de la funcion getDiasEntreFechas a getDiasEntreDates
 *                   Añadida la función getDiasEntreTimestamp
 * v.2.13 12/06/2024 Añadida la función getMesHoy.
 * v.2.14 01/05/2023 Añadida la función getFechayHoraDeTimestamp
 * v.2.15 24/12/2025 Añadida la funcion getAgnoMes
 */

import moment from "moment/moment";
import {stringWithZerosIzq} from "./StringUtils"


export const getDateFromTimestamp = (valueTimestamp) => {
    return moment.unix(valueTimestamp / 1000);
}

export const getTimestampFromNow = () => {
    let dateAhora= new Date();
    return dateAhora.getTime();
}


export const getDateFromNowSinHora = () => {
    console.log("> getDateFromNowSinHora ");
    let dateAhora= new Date();
    dateAhora.setHours(0);
    dateAhora.setMinutes(0);
    dateAhora.setSeconds(0);
    dateAhora.setMilliseconds(0);
    console.log("dateAhora: ", dateAhora);
    return dateAhora;
}

export const getTimestampFromNowSinHora = () => {
    let dateAhora= getDateFromNowSinHora();
    return dateAhora.getTime();
}


export const getTimestampFromDate = (valueDate) => {
    return valueDate.getTime();
}

export const getTimestampFromTimestampHora = (fechaTimestamp, horaCadena) => {
    if (fechaTimestamp && horaCadena) {
        let componentesHora = horaCadena.split(":");
        const dateResultado= new Date(fechaTimestamp);
        dateResultado.setHours(componentesHora[0]);
        dateResultado.setMinutes(componentesHora[1]);
        dateResultado.setSeconds(0);
        dateResultado.setMilliseconds(0);
        return dateResultado.getTime();
    }
}

export const getFormattedFromTimestampAndFormat = (value, format) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format(format);
    }
    return value;
}

export const getFormattedISO8601FromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.toISOString();
    }
    return value;
}



export const getFormattedDateFromTimestamp = (tsValue) => {
    //console.log("getFormattedDateFromTimestamp:");
    //console.log("value: ", tsValue);
    let sValue= "";
    if (tsValue) {
        const date = moment.unix(tsValue / 1000);
        sValue = date.format("DD/MM/YYYY");
    }
    //console.log("sValue: ", sValue);
    return sValue;
}

export const getDiaSemanaFromTimestamp= (value) => {
    console.log("* getDiaSemanaFromTimestamp");
    console.log("value: ", value);
    if (value) {
        let date = moment.unix(value / 1000);
        let diaSemana= date.day();
        return getDayName(diaSemana);
    }
    return value;
}

export const getFormattedDateHyphenFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD-MM-YYYY");
    }
    return value;
}


export const getFormattedDateFromDate = (value) => {
    if (value) {
        return getFormattedDateFromTimestamp (value.getTime());
    }
    return value;
}

export const getFormattedHoraFromDate = (valueDate) => {
    if (valueDate) {
        return getFormattedHoraFromTimestamp(valueDate.getTime());
    }
    return "";
}

export const getFormattedDateTimeFromDate = (value) => {
    if (value) {
        return getFormattedDateTimeFromTimestamp (value.getTime());
    }
    return value;
}

//Cadena yyyy-mm-dd
export const getFormattedDateInversaFromDate= (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const getFormattedDateTimeFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD/MM/YYYY HH:mm:ss");
    }
    return value;
}

export const getFormattedDateTimeMinutesFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD/MM/YYYY HH:mm");
    }
    return value;
}

export const getFormattedDateTimeFromCadenaISO = (cadena) => {
    let date = new Date(cadena);
    let cadenaISO = getFormattedDateTimeFromDate(date);
    return cadenaISO;
}
export const getFormattedTimeFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("HH:mm");
    }
    return value;
}

export const getFormattedHoraFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("HH");
    }
    return value;
}

export const getFormattedTimeFromTimestampWithFormat = (formato, value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format(formato);
    }
    return value;
}

export const getDayMonthDayOfWeekFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        let day = parseInt(date.format("DD"), 10);
        let month= parseInt(date.format("MM"), 10);
        let dayOfWeek= date.day();
        return {day: day, month: month, dayOfWeek: dayOfWeek};
    }
    return null;
}

export const getFormattedDateNow = () => {
    return getFormattedDateFromTimestamp(Date.now());
}

export const getFormattedDateTimeNow = () => {
    return getFormattedDateTimeFromTimestamp(Date.now());
}

export const getFormattedISO8601Ahora = () => {
    return getFormattedISO8601FromTimestamp( (new Date()).getTime() );
}

export const getFormattedDateTimeAhoraForFile = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("YYYYMMDD_HHmmss");
    return value;
}


export const getFormattedHoraAhora = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("HH:mm");
    return value;
}

export const getFormattedMesAgnoFromNow = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("MM/YYYY");
    return value;
}

export const getFormattedAgnoFromNow = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("YYYY");
    return value;
}

export const getFormattedAgnoYYFromNow = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("YY");
    return value;
}

export const getMinutosHastaAhora = (stringAntes) => {
    var stringAhora= getFormattedDateTimeNow();
    return getMinutosEntreFechas(stringAntes, stringAhora);
}

export const getMinutosEntreFechas = (stringAntes, stringDespues) => {
    var momentAntes= moment(stringAntes, "DD/MM/YYYY HH:mm:ss");
    let momentDespues= moment(stringDespues, "DD/MM/YYYY HH:mm:ss");
    let difMinutos= momentDespues.diff(momentAntes, "minutes");
    return difMinutos;
}

export const getMinutosEntreDates = (dateAntes, dateDespues) => {
    let diff = dateDespues - dateAntes;
    let diffMinutos = diff/(1000*60);
    return Math.abs(diffMinutos);
}

export const getMinutosEntreDatesSinAbs = (dateAntes, dateDespues) => {
    let diff = dateDespues - dateAntes;
    let diffMinutos = diff/(1000*60);
    return diffMinutos;
}

export const getSegundosEntreDates = (dateAntes, dateDespues) => {
    let diff = dateDespues - dateAntes;
    let diffSegundos = diff/(1000);
    return Math.abs(diffSegundos);
}

export const getSegundosConSignoEntreDates = (dateAntes, dateDespues) => {
    let diff = dateDespues - dateAntes;
    let diffSegundos = diff/(1000);
    return diffSegundos;
}

export const getSegundosDesdeMinutosSegundos= (minutossegundos) => {
    console.log("getSegundosDesdeMinutosSegundos:");
    console.log("minutossegundos: ", minutossegundos);
    let segundos= 0;
    let partes= minutossegundos.split(":");
    if (partes.length == 2)
        segundos= Number(partes[0])*60 + Number(partes[1]);
    //console.log("segundos: " , segundos);
    return segundos;

}

export const getSegundosDesdeHorasMinutos= (horasminutos) => {
    console.log("getSegundosDesdeHorasMinutos:");
    console.log("horasminutos: ", horasminutos);
    let segundos= 0;
    let partes= horasminutos.split(":");
    if (partes.length == 2)
        segundos= Number(partes[0])*3600 + Number(partes[1])*60;
    console.log("segundos: " , segundos);
    return segundos;

}


export const getDiasEntreDates= (dateAntes, dateDespues) => {
    let diff = dateDespues.getTime() - dateAntes.getTime();
    let diffDias = diff/ (1000 * 3600 * 24)+1;
    return diffDias;
}

export const formatearSegundosEnHora = (segundosTotal) =>{
    console.log("------formatearSegundosEnHora: ", segundosTotal);
    let minutosTotal= Math.trunc(segundosTotal / 60);
    console.log("minutosTotal: ", minutosTotal);
    let segundos= segundosTotal % 60;
    console.log("segundos: ", segundos);
    let horas= Math.trunc(minutosTotal / 60);
    console.log("horas: ", horas);
    let minutos= minutosTotal % 60;
    console.log("minutos: ", minutos);
    let cadena= stringWithZerosIzq(horas.toString(),2) + ":"  +
           stringWithZerosIzq(minutos.toString(),2) + ":"  +
           stringWithZerosIzq(segundos.toString(),2);
    console.log("cadena: ", cadena);
    return cadena;
}

export const getDayName = (day) => {
    switch (day){
        case 0: return "Domingo";
        case 1: return "Lunes";
        case 2: return "Martes";
        case 3: return "Miércoles";
        case 4: return "Jueves";
        case 5: return "Viernes";
        case 6: return "Sábado";
        default: return "-";
    }
}


//Formato esperado de entrada hh:mm
export const getTimeFromFormattedString = (timeStr) => {
    if (!timeStr)
        return null;
    var parts = timeStr.split(":");
    let hora= new Date();
    hora.setHours(parts[0]);
    hora.setMinutes(parts[1]);
    hora.setSeconds(0);
    return hora;
}

export const getStringFromDate = (date) => {
    if (date) {
        return moment(date).format("DD/MM/YYYY");
    }
    return "";
}

//Fusion
export const getStringFromTime = (date) => {
    if (date) {
        return moment(date).format("HH:MM:SS");
    }
    return "";
}

//Formato esperado de entrada dd/mm/yyyy
export const getDateFromFormattedString = (dateStr) => {
    if (!dateStr)
        return null;
    var parts = dateStr.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0])
}

//Formato esperado de entrada
export const getDateFromFormattedStringHyphenReverse = (dateStr) => {
    //console.log("getDateFromFormattedStringHyphenReverse: ", dateStr);
    if (!dateStr)
        return null;
    var parts = dateStr.split("-");
    //console.log("-->>> getDateFromFormattedStringHyphenReverse: ", dateStr);
    //console.log("parts: ", parts );
    return new Date(parts[0], parts[1] - 1, parts[2])
}

export const getDateFromFormattedStringHyphen = (dateStr) => {
    if (!dateStr)
        return null;
    var parts = dateStr.split("-");
    console.log("-->>> getDateFromFormattedStringHyphen: ", dateStr);
    console.log("parts: ", parts );
    return new Date(parts[2], parts[1] - 1, parts[0])
}

//Formato esperado de entrada dd/mm/yyyy hh:mm:ss
//Fusion modificado
export const getDateTimeFromFormattedString = (dateStr) => {
    if (!dateStr)
        return null;
    var parts = dateStr.split(" ");
    if (parts.length == 1)
        parts[1]= "00:00:00";
    var dateParts= parts[0].split("/");
    var timeParts= parts[1].split(":");
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2], 0);
}

//Formato esperado de entrada de fecha dd-mm-yyyy y hora hh:mm
export const getDateFromFormattedStringHyphensAndTime = (dateStr, timeStr) => {
    var dateParts=  dateStr.split("-");
    var timeParts= timeStr.split(":");
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], 0, 0)
}

export const esCorrectaDateFormattedString = (dateStr) => {
    if (!dateStr)
        return false;
    var parts = dateStr.split("/");
    console.log(parts);
    return parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4;
}

//La entrada y salida son un Date
export const addDias= (date, dias) => {
    if (date){
        var dateNueva = new Date(date);
        dateNueva.setDate(date.getDate() + dias);
        return dateNueva;
    }
}

//La entrada y salida son timestamp
export const addDiasTimestampBad= (timestamp, dias) => {
    console.log("*** addDiasTimestamp: ")
    let dtOriginal= new Date(timestamp);
    console.log("origen: ", dtOriginal);
    console.log("dias: ", dias);
    if (dtOriginal){
        var dtNueva = new Date(dtOriginal);
        console.log("dtOriginal.getDate(): ", dtOriginal.getDate());
        dtNueva.setDate(dtOriginal.getDate() + dias);
        console.log("nuevafecha: ", dtNueva);
        return dtNueva.getTime();
    }
}

export const addDiasTimestampDeEj2Personal= (timestamp, dias) => {
    let date= new Date(timestamp);
    if (date){
        var dateNueva = new Date(date);
        dateNueva.setDate(date.getDate() + dias);
        return dateNueva.getTime();
    }
}
//La entrada y salida son timestamp
export const addDiasTimestamp= (timestamp, dias) => {
    let dtOriginal= new Date(timestamp);
    if (dtOriginal){
        var dtNueva = new Date(dtOriginal.getFullYear(), dtOriginal.getMonth(),dtOriginal.getDate() + Number(dias));
        return dtNueva.getTime();
    }
}

export const getDiasEntreTimestamp= (timestampAntes, timestampDespues) => {
    let diff = timestampDespues - timestampAntes;
    let diffDias = diff/ (1000 * 3600 * 24)+1;
    return diffDias;
}

//La entrada y salida son un Date
export const addSegundos= (date, segundos) => {
    console.log("ADD SEGUNDOS");
    if (date){
        var dateNueva = new Date(date);
        dateNueva.setSeconds(date.getSeconds() + segundos);
        return dateNueva;
    }
}

export const getMinDate= () =>{
    return new Date(2000, 0, 1);
    //return getDateFromFormattedString("01/01/2000");
}

export const getMinTimestamp= () => {
    let minDate= new Date(2000, 0, 1);
    return minDate.getTime();
}

export const esFechaMayorQueMin= (date) => {
    return date > getMinDate();
}

export const esTimestampMayorQueMin= (timestamp) => {
    return timestamp > getMinTimestamp();
}

//IntervaloA dentro de IntervaloB
export const timestampIntervaloDentroIntervalo= (desdeA, hastaA, desdeB, hastaB) => {
    console.log("timestampIntervaloDentroIntervalo");
    console.log("desdeA: ", desdeA, "  hastaA:", hastaA);
    console.log("desdeB: ", desdeB, "  hastaB:", hastaB);
    return desdeA >= desdeB && desdeA <= hastaB && hastaA >= desdeB && hastaA <= hastaB;
}



//Devuelve un array de Dates
export const getDatesLunesPeriodo= (fechaDesde, fechaHasta) => {
    return getDatesDiaPeriodo(fechaDesde, fechaHasta, 1);
}

//Devuelve un array de Dates
// 0-> Domingo, 1->Lunes... 6->Sabado
//fechaDesde y fechaHasta son timestamps
export const getDatesDiaPeriodo= (fechaDesde, fechaHasta, dia) => {
    let desde = moment(fechaDesde);
    let hasta = moment(fechaHasta);

    let dias = [];
    let current = desde.clone();

    //Añadimos el dia buscado de la primera semana
    //Lo hacemos pq el bucle posterior se lo salta
    //Si pedimos desde un martes y buscamos los sábados... esto añade el sabado de esa misma semana.
    let primerDia= desde.clone();
    if (desde.day() <= dia){
        primerDia.day(dia);
        if (primerDia.isBefore(hasta))
            dias.push(primerDia.toDate());
    }


    while (current.day(7 + dia).isBefore(hasta)) {
        dias.push(current.clone().toDate());
    }
    return dias;

}

//fechaDesde y fechaHasta son timestamps
//Generamos un array de Dates
export const getDatesTodosDiasPeriodo= (fechaDesde, fechaHasta) => {
    let desde = moment(fechaDesde);
    let hasta = moment(fechaHasta);

    let dias = [];
    let current = desde.clone();

    //Añadimos el dia buscado de la primera semana
    //Lo hacemos pq el bucle posterior se lo salta
    //Si pedimos desde un martes y buscamos los sábados... esto añade el sabado de esa misma semana.
    let dia= desde.clone();
    dias.push(dia.toDate());
    while (dia.isBefore(hasta)){
        dias.push(dia.clone().toDate());
        dia= dia.add(1, 'd');
    }
    return dias;

}


//Devuelve un array de Dates
// El origen es una cadena de dia/mes#....#dia/Mes
export const getDatesDiaCadenaMesAgno= (cadenaDias) => {
    let dias = [];

    //console.log("XXXXX getDatesDiaCadenaMesAgno");
    //console.log("cadenaDias: ", cadenaDias);
    if (cadenaDias != "") {
        let arrayCadenasDias = cadenaDias.split("#");
        arrayCadenasDias.forEach((cadenaDia) => {
            if (cadenaDia != "") {
                let dtDia = getDateFromFormattedString(cadenaDia);
                dias.push(dtDia);
            }
        });
    }
    //console.log("dias: ", dias);
    return dias;
}

export const diaAnteriorADia= (dateDiaA, dateDiaB) => {
    return dateDiaA.getTime() < dateDiaB.getTime();
}

export const diaAnteriorIgualADia= (dateDiaA, dateDiaB) => {
    return dateDiaA.getTime() <= dateDiaB.getTime();
}


export const esDomingo= (dateDia) => {
    return dateDia.getDay() == 0;
}


export const esSabado= (dateDia) => {
    return dateDia.getDay() == 6;
}

//Devuelve un Date
export const siguienteDomingo= (dateDia) => {
    //console.log("siguienteDomingo");

    //console.log("dateDia: ", getFormattedDateFromDate(dateDia));
    let diaSemana=  dateDia.getDay();
    //console.log("diaSemana: ", diaSemana);
    let numDiasSumar= 7 - diaSemana;
    //console.log("numDiasSumar: ", numDiasSumar);
    let newDia= addDias(dateDia, numDiasSumar);
    //console.log("newDia: ", getFormattedDateFromDate(newDia));
    return newDia;
}

//Devuelve un Date
export const anteriorLunes= (dateDia) => {
    //console.log("anteriorLunes");

    //console.log("dateDia: ", getFormattedDateFromDate(dateDia));
    let diaSemana=  dateDia.getDay();
    //console.log("diaSemana: ", diaSemana);
    let numDiasRestar= diaSemana == 0 ? diaSemana - 6 : diaSemana - 1;
    //console.log("numDiasRestar: ", numDiasRestar);
    let newDia= addDias(dateDia, -numDiasRestar);
    //console.log("newDia: ", getFormattedDateFromDate(newDia));
    return newDia;
}


export const calcularDateFromCadena= (cadena) => {
    //console.log ("!!! CALCULARDATEFROM CADENA");
    let dia, mes, agno;
    let hoy= getDateFromNowSinHora();
    let partes = [];

    if (!cadena)
        return hoy;

    if (cadena.includes("/")) {
        partes = cadena.split("/");
    }
    else {
        let tamaCadena=  cadena.length;
        if (tamaCadena == 1)
            partes.push(cadena);
        else {
            if (tamaCadena >= 2)
                partes.push(cadena.substring(0, 2));
            if (tamaCadena >= 4)
                partes.push(cadena.substring(2, 4));
            if (tamaCadena >= 6)
                partes.push("20" + cadena.substring(4, 6));
        }
    }

    if (partes.length >= 1) {
        //Asumimos que es el dia.
        dia = Number(partes[0]);
        if (isNaN(dia))
            return null;
        if (dia < 1 || dia > 31)
            return null;
    }
    if (partes.length >= 2) {
        //console.log(">= 2");
        //Asumimos que es el nes.
        mes = Number(partes[1]) - 1;
        if (isNaN(mes))
            return null;
        if (mes < 0 || mes > 11)
            return null;
    } else {
        mes = hoy.getMonth();
        agno = hoy.getFullYear();
    }

    if (partes.length == 3) {
        //Asumimos que es el agno.
        agno = Number(partes[2]);
        if (isNaN(agno))
            return null;
    } else {
        agno = hoy.getFullYear();
    }

    //console.log("dia: ", dia, " mes: ", mes, " agno: ", agno);
    let fecha= new Date(agno, mes, dia);
    return fecha;

}

//Enero es el mes 1
export const getMesNumeroDias= (agno, mes) => {
    return new Date(agno, mes, 0).getDate();
}

export const getMesNombre= (mes) => {
    switch (mes){
        case 1: return "Enero";
        case 2: return "Febrero";
        case 3: return "Marzo";
        case 4: return "Abril";
        case 5: return "Mayo";
        case 6: return "Junio";
        case 7: return "Julio";
        case 8: return "Agosto";
        case 9: return "Septiembre";
        case 10: return "Octubre";
        case 11: return "Noviembre";
        case 12: return "Diciembre";
    }
}

export const getDiaSemanaUnoDelMes= (agno, mes) => {
    //console.log("+++ getDiaSemanaUnoDelMes");
    let primerDiaMes = new Date(agno, mes-1, 1); //Enero es mes 0. Por eso restamos uno
    //console.log("primerDiaMes: ", primerDiaMes);
    let dia=  primerDiaMes.getDay();
    //console.log("dia: ", dia);
    let diaCorregido= dia == 0 ? 7 : dia;
    //console.log("diaCorregido: ", diaCorregido);

    return  diaCorregido;
}

export const minutosToCadenaHorasMinutos= (minutosOrigen) => {
    //console.log("minutosToCadenaHorasMinutos: ", minutosOrigen);
    if (minutosOrigen && minutosOrigen != 0) {
        let horas = Math.trunc(minutosOrigen / 60);
        let minutos = minutosOrigen % 60;
        let cadMinutos = minutos.toString();
        if (cadMinutos.length < 2)
            cadMinutos = "0" + cadMinutos;
        let cadHoras = horas.toString() + ":" + cadMinutos;
        return cadHoras;
    }
    else{
        return "00:00";
    }
}

export const getMesAgnoHoy= () => {
    let hoy= new Date();
    return {agno: hoy.getFullYear(), mes: hoy.getMonth()+1 };
}

export const getMesAgno= (dtFecha) => {
    //return {agno: dtFecha.getFullYear(), mes: dtFecha.getMonth()+1 };
    return {agno: dtFecha.getFullYear(), mes: dtFecha.getMonth()};
}


export const getAgnoHoy= () => {
    let hoy= new Date();
    return hoy.getFullYear();
}

export const getMesHoy= () => {
    let hoy= new Date();
    return hoy.getMonth()+1;
}

//Nuevo
export const getCadenaISO8601FromParts = (dia, mes, agno) => {
    let cadena= stringWithZerosIzq(agno.toString(),4) + "-"  +
        stringWithZerosIzq(mes.toString(),2) + "-"  +
        stringWithZerosIzq(dia.toString(),2) + "T00:00:00Z";
    return cadena;
}

export const getFechayHoraDeTimestamp = (tsFechahoraInicial) => {
    let dtFechahora= new Date();
    if (tsFechahoraInicial)
        dtFechahora = new Date(tsFechahoraInicial);
    const yyyy = dtFechahora.getFullYear();
    const mm = String(dtFechahora.getMonth() + 1).padStart(2, '0');
    const dd = String(dtFechahora.getDate()).padStart(2, '0');
    const hh = String(dtFechahora.getHours()).padStart(2, '0');
    const mi = String(dtFechahora.getMinutes()).padStart(2, '0');

    return {
        //fecha: `${yyyy}-${mm}-${dd}`,
        fecha: yyyy + "-" + mm + "-"+ dd,
        hora: hh + ":" + mi
    };
}

export const getFechayHoraDeDate = (dtFechahoraInicial) => {
    let dtFechahora=  dtFechahoraInicial ? dtFechahoraInicial : new Date();
    const yyyy = dtFechahora.getFullYear();
    const mm = String(dtFechahora.getMonth() + 1).padStart(2, '0');
    const dd = String(dtFechahora.getDate()).padStart(2, '0');
    const hh = String(dtFechahora.getHours()).padStart(2, '0');
    const mi = String(dtFechahora.getMinutes()).padStart(2, '0');

    return {
        //fecha: `${yyyy}-${mm}-${dd}`,
        fecha: yyyy + "-" + mm + "-"+ dd,
        hora: hh + ":" + mi
    };
}